export enum PlaylistType {
    BestHitFrance = "Best Hit - France",
    RockDeutschland = "Rock - Deutschland",
    GuiltyPleasures = "Plaisirs coupables",
    France = "100% France",
    BestHitUsa = "Best Hit - USA"
}